/* eslint-disable react-hooks/exhaustive-deps */
import { REDEEM_PATH } from 'constant/path';
import { ACCESS_TOKEN } from 'constant/token';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { authAction } from 'reducers/auth/action';
import { useAppDispatch } from 'reducers/models';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from 'utils/browserStorageUtil';
import { decodeJwt } from 'utils/helperFunctions';

const useValidateToken = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const [isTokenChecked, setIsTokenChecked] = useState(false);
  const accessToken = getLocalStorage(ACCESS_TOKEN);

  const validate = async (tokenToValidate: string) => {
    if (isTokenChecked) return;
    try {
      if (!tokenToValidate) throw new Error();

      decodeJwt(tokenToValidate);
      setLocalStorage(ACCESS_TOKEN, tokenToValidate);
      dispatch(authAction.setIsAuth(true));
    } catch (error) {
      if (!getLocalStorage('accessRefreshToken')) {
        removeLocalStorage(ACCESS_TOKEN);
      }
    } finally {
      setIsTokenChecked(true);
    }
  };

  useEffect(() => {
    if (pathname !== REDEEM_PATH) {
      validate(accessToken);
    }
  }, [isTokenChecked, pathname]);

  return {
    isTokenChecked,
  };
};

export default useValidateToken;
